import {request} from "./request";

export const getProjectTemplateList = queryParams => {
  return request.get({
    path: "/engine/project/template/list",
    queryParams,
  });
};
